import { useContext, useEffect, useState } from 'react';
import { ToastOptions } from 'react-toastify';
import { toast } from '../../util/toasts';
import { Typography } from '../../components/typography/typography';
import useLocalStorage from 'use-local-storage';
import { StripeAccount, StripeAccountStatus } from '../../clients/quipli-service/payment-config/payment-config';
import { usePaymentConfigApiV1 } from '../../clients/quipli-service/payment-config/payment-config-api-v1';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { TenantContext } from '../../context/tenant-context';
import { useNavigate } from 'react-router-dom';

export const PendingStripeCustomMigrationMessage = () => {
  const { getStripeAccount, getStripeAuthUrl } = usePaymentConfigApiV1();
  const { getCountry } = useAPI();
  const { contextPath } = useContext(TenantContext);
  const navigate = useNavigate();

  const [stripeAccount, setStripeAccount] = useState<StripeAccount>();
  const [country, setCountry] = useState<string>();
  const [messageReceived, setMessageReceived] = useLocalStorage('stripePendingMigrationMessageReceived', '');

  useEffect(() => {
    Promise.all([getStripeAccount(), getCountry()]).then(([stripeAccount, country]) => {
      setStripeAccount(stripeAccount);
      setCountry(country.code);
    });
  }, []);

  const toastOptions: ToastOptions = {
    autoClose: false,
    theme: 'dark',
    position: 'top-center',
    toastId: 2,
  };

  async function signupStep(userInfo?: StripeAccount) {
    if (!userInfo) {
      // shouldn't actually happen, but just in case just navigate to setup page
      navigate(`${contextPath}manager/quipli-pay`);
    } else if (userInfo.accountType === 'custom' && country == 'US') {
      navigate(`${contextPath}manager/quipli-pay/customConnectOnboarding/${userInfo.stripeAccountId}`);
    } else {
      const authUrl = await getStripeAuthUrl(userInfo.stripeAccountId);
      window.location.href = authUrl.url;
    }
  }

  const ToastMessage = () => (
    <div onClick={() => signupStep(stripeAccount)}>
      <Typography type={'text-sm'}>Your Stripe Account Requires Review!</Typography>
      {stripeAccount?.missingRequirements && (
        <ul>
          {stripeAccount.missingRequirements.map((requirement, idx) => (
            <li key={idx}>
              <Typography type="text-xs">{requirement}</Typography>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  if (
    stripeAccount?.accountType === 'custom' &&
    (stripeAccount?.accountStatus === StripeAccountStatus.Pending ||
      stripeAccount?.accountStatus === StripeAccountStatus.Incomplete) &&
    messageReceived.length == 0
  ) {
    toast(ToastMessage, 'error', toastOptions);
    setMessageReceived('seen');
  }

  return <></>;
};
